import { Injectable } from '@angular/core';
import { MaritalStatusesState, MaritalStatusesStore } from './marital-statuses.store';
import { MaritalStatusesQuery } from './marital-statuses.query';
import { ApiService } from '@core/services/api/api.service';
import { JsonApiEntityService } from '../jsonentity/json-api-entity.service';
import { RelationConfigService } from '@core/state/relation-config';

@Injectable({providedIn: 'root'})
export class MaritalStatusesService extends RelationConfigService<MaritalStatusesState> {
  protected filterType = 'MARITAL_STATUS';

  constructor(private store: MaritalStatusesStore,
              private query: MaritalStatusesQuery,
              private service: ApiService,
  ) {
    super(store, query, service);
  }
}
